import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class CustomBoldEditing extends Plugin {
    init() {
        const editor = this.editor;
        editor.model.schema.extend('$text', {
            allowAttributes: 'newBold'
        });

        // store <b> tag as attribute on text
        editor.conversion.for('upcast').elementToAttribute({
            model: 'newBold',
            view: 'b',
            converterPriority: 'high'
        });

        // convert newBold attribute back to <b> tags
        editor.conversion.for('downcast').attributeToElement({
            model: 'newBold',
            view: 'b',
            converterPriority: 'high'
        });

        this.listenTo(this.editor.editing.view.document, 'click', () => {
            const getAttr = this.editor.model.document.selection.getAttributes();
            for (const i of getAttr) {
                if (i[0] === "newBold") {
                    this.editor.commands.get("bold").value = true;
                }
            }
        });

        this.editor.commands.get('bold').on('execute', (e) => {
            const getAttr = this.editor.model.document.selection.getAttributes();
            const selection = this.editor.model.document.selection;
            for (const i of getAttr) {
                if (i[0] === "newBold") {
                    e.stop()
                    this.editor.model.change(writer => {
                        writer.removeAttribute('newBold', selection.getFirstRange())
                    });
                }
            }
        }, { priority: 'high' });
    }
}
